import { useNavigate } from 'react-router-dom';

import { JobSignalPanel } from '@/modules/jobs/signal/components/JobSignalPanel';
import { useJobCreateSubmit } from '@/modules/jobs/signal/useJobCreateSubmit';
import { getPublicShortlistEditPath } from '@/modules/public-shortlist/publicShortlist';

/**
 * The recruiter's create screen: the signal panel is the real, persisting create
 * form (persona-split — recruiters also get the workflow settings).
 */
const JobAdd = () => {
  const navigate = useNavigate();
  const signalSubmit = useJobCreateSubmit((createdJob) => {
    // a job created with the public list enabled comes back with its code set — route to the shortlist editor
    if (createdJob?.publicCandidateListCode && createdJob.id) {
      navigate(getPublicShortlistEditPath(createdJob.id));
      return;
    }
    navigate('/jobs');
  });

  return (
    <JobSignalPanel
      submitting={signalSubmit.submitting}
      submitError={signalSubmit.error}
      onSubmit={signalSubmit.onSubmit}
    />
  );
};

export default JobAdd;
